import { configureTelemetry } from '@ms/yammer-telemetry';
import { AdalRedirectAuthenticator, isIFrameAuthRedirect } from '@ms/yammer-web-authenticators';
import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';
import { hasMetaOsHubContext } from '@ms/yammer-web-support/dist/metaOsHub';
import setupAuthenticator, { isNAASupportAvailable } from 'bootstrap/auth';
import config from 'bootstrap/config';
import loadPolyfills from 'bootstrap/entries/2-polyfill';
import 'bootstrap/publicPath';

import authBootstrap from './auth';

(async () => {
  await loadPolyfills();
  const isNestedAppAuthSupported = await isNAASupportAvailable();

  configureTelemetry({
    config,
    telemetryClientId: config.application.applicationId,
    hostingConfig: readHostingConfiguration(),
    skipNextCleanup: true,
    registerUnhandledEventsListener: true,
    clientContext: getClientContext(),
    isMsal: isNestedAppAuthSupported,
  });

  const authenticator = await setupAuthenticator();
  const hasMetaOsContext = await hasMetaOsHubContext();

  if (!hasMetaOsContext && isIFrameAuthRedirect() && authenticator instanceof AdalRedirectAuthenticator) {
    authenticator.handleTokenInUrl();

    return;
  }

  await authBootstrap();
})();
